import { ChevronLeft, ChevronRight } from 'lucide-react';
import { fmtFechaLarga, hoyAR, sumarDias } from '../util/format';

/** Selector de día (YYYY-MM-DD, hora argentina) con botones de día anterior y siguiente. */
export function SelectorFecha({ fecha, onCambiar }: { fecha: string; onCambiar: (f: string) => void }) {
  const hoy = hoyAR();
  return (
    <div className="actions">
      <span className="muted" style={{ fontSize: 12 }}>{fmtFechaLarga(fecha)}</span>
      <button type="button" className="icon" aria-label="Día anterior" title="Día anterior" onClick={() => onCambiar(sumarDias(fecha, -1))}>
        <ChevronLeft aria-hidden />
      </button>
      <label className="field" style={{ minWidth: 0 }}>
        <span className="sr-only">Fecha</span>
        <input type="date" value={fecha} max={hoy} onChange={(e) => e.target.value && onCambiar(e.target.value)} />
      </label>
      <button type="button" className="icon" aria-label="Día siguiente" title="Día siguiente" disabled={fecha >= hoy} onClick={() => onCambiar(sumarDias(fecha, 1))}>
        <ChevronRight aria-hidden />
      </button>
      <button type="button" className="btn-sm" disabled={fecha === hoy} onClick={() => onCambiar(hoy)}>
        Hoy
      </button>
    </div>
  );
}
